export default __webpack_public_path__ + "static/media/centro-europeo.9cf8bce6.jpg";